import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {WidgetBarComponent} from './widget-bar.component';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [
    WidgetBarComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [WidgetBarComponent]
})
export class WidgetBarModule {
}
